"use client";

import React from 'react';
import TestimonialDisplay from '@/components/common/TestimonialDisplay';
import testimonialsData from '../../../config/testimonials.json';

interface TestimonialsProps {
  useNeutralBackground?: boolean;
  backgroundColor?: string;
  showTitle?: boolean;
}

const Testimonials = ({ 
  useNeutralBackground = false, 
  backgroundColor = "#121212",
  showTitle = true 
}: TestimonialsProps) => {
  
  // Choose accent color based on the background
  const accentColor = useNeutralBackground ? "#3b82f6" : "#60a5fa";
  
  return (
    <div className="w-full text-white py-12 md:py-20" style={{ backgroundColor }}>
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
        {showTitle && (
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-gray-100">
              What Our Customers Say
            </h2>
            <p className="text-gray-300 max-w-2xl mx-auto text-base md:text-lg">
              Hear from our satisfied customers about how MeetMinutes has transformed their meeting experience
            </p>
          </div>
        )}
        
        {/* Use the TestimonialDisplay component */}
        <TestimonialDisplay 
          testimonials={testimonialsData.testimonials}
          darkMode={true}
          accentColor={accentColor}
          backgroundColor={backgroundColor}
          showQuoteSymbol={true}
          autoPlaySpeed={6000}
          className="mx-auto"
        />
      </div>
    </div>
  );
};

export default Testimonials; 